import { Box, Divider, FormControlLabel, Switch, Typography } from '@mui/material';
import type React from 'react';

interface FeatureFlagsProps {
  hideBillingFromUsers: boolean;
  handleBillingVisibilityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FeatureFlags: React.FC<FeatureFlagsProps> = ({
  hideBillingFromUsers,
  handleBillingVisibilityChange,
}) => {
  return (
    <>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Feature Flags
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <FormControlLabel
        control={
          <Switch
            checked={hideBillingFromUsers}
            onChange={handleBillingVisibilityChange}
            name="hideBillingFromUsers"
            color="primary"
          />
        }
        label={
          <Box>
            <Typography variant="body1">Hide Billing from Users</Typography>
            <Typography variant="body2" color="text.secondary">
              Hides the estimated cost chips and billing details from all users in your
              organization.
            </Typography>
          </Box>
        }
        sx={{ mb: 2, alignItems: 'flex-start' }}
      />
    </>
  );
};
